import { render } from "./StaffTable.vue?vue&type=template&id=c3b3a99c&scoped=true"
import script from "./StaffTable.vue?vue&type=script&lang=js"
export * from "./StaffTable.vue?vue&type=script&lang=js"

import "./StaffTable.vue?vue&type=style&index=0&id=c3b3a99c&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b3a99c"]])

export default __exports__